import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OskComponent } from './osk.component';
import { FasServiceTableComponent } from 'fas-services';
import { ButtonModule } from 'primeng/button';
import { OskDetailsComponent } from './osk-details/osk-details.component';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OskAddNewComponent } from './osk-add-new/osk-add-new.component';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { SubscriptionTagComponent } from '../../shared/components/subscription-tag/subscription-tag.component';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';


@NgModule({
  declarations: [
    OskComponent,
    OskDetailsComponent,
    OskAddNewComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FasServiceTableComponent,
    TabViewModule,
    DialogModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    AutoCompleteModule,
    DynamicDialogModule,
    SubscriptionTagComponent,
    CheckboxModule,
    TooltipModule,
    InputNumberModule,
    InputMaskModule
  ],
  providers: [DialogService]
})
export class OskModule { }
